export const freigabeWarningDialogContent = {
  id: 'manuellerAusschreibungsprozess',
  title: 'Kein zugesagtes Angebot bekannt',
  contentVAManuellerAusschreibungsprozess:
    'Du versuchst, eine Veranstaltung im manuellen Ausschreibungsprozess freizugeben. Prüfe, ob zu allen Angeboten Zusagen vorliegen und die Expertenauswahl in Viva dem Angebot entspricht, bevor du die Veranstaltung freigibst.',
  contentVAKurzfristigerErsatztermin:
    'Du versuchst, einen kurzfristigen Ersatztermin ohne integrierten Angebotsprozess freizugeben. Bist du sicher, dass du die Veranstaltung freigeben möchtest? Stelle sicher, dass die Expertenauswahl in Viva dem Angebot entspricht.',
  contentDG:
    'Du versuchst einen Durchgang im manuellen Ausschreibungsprozess freizugeben. Prüfe, ob zu allen Angeboten Zusagen vorliegen, bevor du den Durchgang freigibst.',
  approveButtonLabel: 'Freigeben',
  questionText: 'Möchtest du den Status trotzdem auf freigegeben wechseln?',
} as const;
